


























import { Component, Vue, Prop } from 'vue-property-decorator';
import { ILogwork } from '@/lib/interfaces';

@Component
export default class LogworkRow extends Vue {
  @Prop() private logwork!: ILogwork;

  private get owner(): boolean {
    return this.$store.state.currentUser._id === this.logwork._user_id;
  }
}
